import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/lib/styles/main.sass'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/lib/components'
import '@fortawesome/fontawesome-free/css/all.css'
import * as directives from 'vuetify/lib/directives'

export default createVuetify({
  components,
  directives
})